module.exports = __webpack_public_path__ + "img-dashboard/register/arrow-up.0108f922.svg";